import React from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../../../api/UrlProvider";
import withTranslations from "../../../../../../../hocs/withTranslations";
import withUserData from "../../../../../../../hocs/withUserData";
import IconMessage from "../../../../../common/IconMessage";
import NoNotificationsIcon from "../../assets/no-notifications.svg";

const NoNotificationsDesktop = ({ translate, className, locale, userData }) => (
  <IconMessage
    imageSrc={NoNotificationsIcon}
    imageHeight={110}
    imageWidth={110}
    link={UrlProvider.getUrl("fe.settingsPageCategory", {
      locale,
      settingsCategory: "notifications"
    })}
    linkText={translate(!userData ? "Log in" : "noNotifications_settings")}
    description={translate("noNotifications_description")}
    className={className}
    title={translate("noNotifications_title")}
  />
);

export default compose(withTranslations, withUserData)(NoNotificationsDesktop);
